var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 104,
    viewBox: "0 0 89 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 87,
    height: 103,
    rx: 7.5,
    fill: "#EBF4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 87,
    height: 103,
    rx: 7.5,
    stroke: "#C9E1EA",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1068_13236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8307 20.0003C15.8307 20.7337 15.2307 21.3337 14.4974 21.3337C13.7641 21.3337 13.1641 20.7337 13.1641 20.0003C13.1641 19.267 13.7641 18.667 14.4974 18.667C15.2307 18.667 15.8307 19.267 15.8307 20.0003ZM14.4974 14.667C13.7641 14.667 13.1641 15.267 13.1641 16.0003C13.1641 16.7337 13.7641 17.3337 14.4974 17.3337C15.2307 17.3337 15.8307 16.7337 15.8307 16.0003C15.8307 15.267 15.2307 14.667 14.4974 14.667ZM14.4974 10.667C13.7641 10.667 13.1641 11.267 13.1641 12.0003C13.1641 12.7337 13.7641 13.3337 14.4974 13.3337C15.2307 13.3337 15.8307 12.7337 15.8307 12.0003C15.8307 11.267 15.2307 10.667 14.4974 10.667ZM18.4974 13.3337C19.2307 13.3337 19.8307 12.7337 19.8307 12.0003C19.8307 11.267 19.2307 10.667 18.4974 10.667C17.7641 10.667 17.1641 11.267 17.1641 12.0003C17.1641 12.7337 17.7641 13.3337 18.4974 13.3337ZM18.4974 14.667C17.7641 14.667 17.1641 15.267 17.1641 16.0003C17.1641 16.7337 17.7641 17.3337 18.4974 17.3337C19.2307 17.3337 19.8307 16.7337 19.8307 16.0003C19.8307 15.267 19.2307 14.667 18.4974 14.667ZM18.4974 18.667C17.7641 18.667 17.1641 19.267 17.1641 20.0003C17.1641 20.7337 17.7641 21.3337 18.4974 21.3337C19.2307 21.3337 19.8307 20.7337 19.8307 20.0003C19.8307 19.267 19.2307 18.667 18.4974 18.667Z",
    fill: "#467077"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1068_13236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPageIcon);
export default __webpack_public_path__ + "static/media/empty-page-icon.d896404bdc09bb58203e1b3cef6c168f.svg";
export { ForwardRef as ReactComponent };